module.exports = __webpack_public_path__ + "static/media/bone-break.9a0a143c.svg";